module.exports = __webpack_public_path__ + "static/media/background__homepage-cta.d9294c2e.jpg";